import {
  FetchTopFavoriteResourcesQuery,
  FetchTopFavoriteResourcesQueryVariables,
  FetchTrendingResourcesQuery,
  FetchTrendingResourcesQueryVariables,
  KnowledgeHubPage,
  KnowledgeHubPageQuery,
  KnowledgeHubPageQueryVariables,
  LatestResourcesByThemeQuery,
  LatestResourcesByThemeQueryVariables,
  LatestResourcesByTopicQuery,
  LatestResourcesByTopicQueryVariables,
  FetchMainLatestResourcesQuery,
  FetchMainLatestResourcesQueryVariables,
  ResourceEntity,
  LatestResourcesByTypeQuery,
  LatestResourcesByTypeQueryVariables,
} from '@/graphql/generated/graphql';
import requestHandler from '../requestHandler';
import { initializeApollo } from '../lib/apollo-client';
import {
  QUERY_FETCH_KNOWLEDGE_HUB_PAGE,
  QUERY_FETCH_LATEST_RESOURCES_BY_THEME,
  QUERY_FETCH_LATEST_RESOURCES_BY_TOPIC,
  QUERY_FETCH_MAIN_LATEST_RESOURCES,
  QUERY_FETCH_TRENDING_RESOURCES,
  QUERY_FETCH_ALL_TIME_FAVOURITE_RESOURCES,
  QUERY_FETCH_LATEST_RESOURCES_BY_TYPEE,
} from '@/graphql/queries/knowledge-hub/knowledge-hub';

export const fetchKnowledgeHubPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<KnowledgeHubPageQuery, KnowledgeHubPageQueryVariables>({
      query: QUERY_FETCH_KNOWLEDGE_HUB_PAGE,
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { page: null };
  }

  return {
    page: data?.knowledgeHubPage?.data?.attributes as KnowledgeHubPage,
  };
};

export const fetchLatestResourcesByTopic = async (
  topic: string | null,
  size: number = 2,
  excludeId: string | null = null,
) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<LatestResourcesByTopicQuery, LatestResourcesByTopicQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES_BY_TOPIC,
      variables: {
        topic,
        excludeId,
        limit: size,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resorces: null };
  }

  return {
    resorces: data?.resources?.data as ResourceEntity[],
  };
};

export const fetchLatestResourcesByTheme = async (theme: string, size: number = 2, page?: number) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<LatestResourcesByThemeQuery, LatestResourcesByThemeQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES_BY_THEME,
      variables: {
        theme,
        limit: size,
        page,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resorces: null };
  }

  return {
    resorces: data?.resources?.data,
    meta: data?.resources?.meta,
  };
};

export const fetchLatestResourcesByType = async (types: string[], size: number = 2, page?: number) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<LatestResourcesByTypeQuery, LatestResourcesByTypeQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES_BY_TYPEE,
      variables: {
        types,
        limit: size,
        page,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resorces: null };
  }

  return {
    resorces: data?.resources?.data,
    meta: data?.resources?.meta,
  };
};

export const fetchLatestResources = async (size: number = 2) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchMainLatestResourcesQuery, FetchMainLatestResourcesQueryVariables>({
      query: QUERY_FETCH_MAIN_LATEST_RESOURCES,
      variables: {
        limit: size,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.resources?.data as ResourceEntity[],
  };
};

export const fetchTrendingResources = async (size: number = 3) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchTrendingResourcesQuery, FetchTrendingResourcesQueryVariables>({
      query: QUERY_FETCH_TRENDING_RESOURCES,
      variables: {
        limit: size,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.trendingResources?.slice(0, size) as ResourceEntity[],
  };
};

export const fetchAllTimePopularFavouriteResources = async (size: number = 2) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchTopFavoriteResourcesQuery, FetchTopFavoriteResourcesQueryVariables>({
      query: QUERY_FETCH_ALL_TIME_FAVOURITE_RESOURCES,
      variables: {
        limit: size,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.topFavoriteResources as ResourceEntity[],
  };
};
